<template>
  <svg
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 13 13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z"
      fill="hsl(186, 100%, 40.2%)"
      stroke="white"
      stroke-width="0.7"
    />
    <path d="M5.53271 8.66357L9.25213 4.68197" stroke="white" />
    <path d="M4.10645 6.7688L6.13766 8.62553" stroke="white" />
  </svg>
</template>
